import * as React from 'react'

function SvgCircLoading({ margin = 'auto', ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{
        margin,
        background: '0 0',
      }}
      width={64}
      height={64}
      viewBox="0 0 100 100"
      preserveAspectRatio="xMidYMid"
      display="block"
      {...props}
    >
      <circle
        cx={50}
        cy={50}
        fill="none"
        stroke="#2849d6"
        strokeWidth={10}
        r={35}
        strokeDasharray="164.93361431346415 56.97787143782138"
      >
        <animateTransform
          attributeName="transform"
          type="rotate"
          repeatCount="indefinite"
          dur="1s"
          values="0 50 50;360 50 50"
          keyTimes="0;1"
        />
      </circle>
    </svg>
  )
}

export default SvgCircLoading
